export interface SilAssumptionState {
    baseRoute: string
    reloadView: boolean
}

export const SIL_ASSUMPTION_BASE_ROUTE = "SIL_ASSUMPTION_BASE_ROUTE"
export const SIL_ASSUMPTION_RELOAD_VIEW = "SIL_ASSUMPTION_RELOAD_VIEW"
